// Portfolio.jsx
import React, { useState, useEffect } from "react";
import "./portfolio.css";
import Menu from "./Menu";

const Portfolio = () => {
  const [items, setItems] = useState(Menu);
  const [selectedImages, setSelectedImages] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const filterItem = (categoryItem) => {
    const updatesItems = Menu.filter((curElem) => {
      return curElem.category === categoryItem;
    });
    setItems(updatesItems);
  };

  const handleImageClick = (images) => {
    if (images && images.length > 0) {
      setSelectedImages(images);
      setCurrentImageIndex(0);
    }
  };

  const handleClose = () => {
    setSelectedImages(null);
    setCurrentImageIndex(0);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : selectedImages.length - 1));
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev < selectedImages.length - 1 ? prev + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImages) return;
      
      if (e.key === 'ArrowLeft') {
        handlePrevImage(e);
      } else if (e.key === 'ArrowRight') {
        handleNextImage(e);
      } else if (e.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImages]);

  return (
    <section className="work container section" id="work">
      <h2 className="section__title">Recent Works</h2>

      <div className="work__filters">
        <span className="work__item" onClick={() => setItems(Menu)}>Everything</span>
        <span className="work__item" onClick={() => filterItem("Programming")}>Programming</span>
        <span className="work__item" onClick={() => filterItem("Design")}>Design</span>
      </div>

      <div className="work__container grid">
        {items.map((elem) => {
          const { id, images, title, client, category } = elem;
          return (
            <div className="work__card" key={id}>
              <div className="work__thumbnail">
                <img src={images[0]} alt="" className="work__img"/>
                <div className="work__mask"></div>
              </div>
              <span className="work__category">{category}</span>
              <h3 className="work__title">{title}</h3>
              <p className="work__client">{client}</p>
              <button 
                onClick={() => handleImageClick(images)} 
                className="work__button"
              >
                <i className="icon-link work__button-icon"></i>
              </button>
            </div>
          )
        })} 
      </div>

      {selectedImages && (
        <div className="image-viewer-overlay" onClick={handleClose}>
          <div className="image-viewer-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>×</button>
            {selectedImages.length > 1 && (
              <>
                <button 
                  className="nav-button prev" 
                  onClick={handlePrevImage}
                  title="Previous (Left Arrow)"
                >
                  ‹
                </button>
                <button 
                  className="nav-button next" 
                  onClick={handleNextImage}
                  title="Next (Right Arrow)"
                >
                  ›
                </button>
              </>
            )}
            <img 
              src={selectedImages[currentImageIndex]} 
              alt="Enlarged view" 
              className="enlarged-image" 
            />
            {selectedImages.length > 1 && (
              <div className="image-counter">
                {currentImageIndex + 1} / {selectedImages.length}
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;